import { Content } from '../interfaces/Content'
import content from './content.json'

const _CONTENT: Content = content

const HOME = _CONTENT.home
const ABOUT = _CONTENT.about
const PROJECTS = _CONTENT.projects
const CONTACT = _CONTENT.contact
const NAVBAR = _CONTENT.navbar

export { HOME, ABOUT, PROJECTS, CONTACT, NAVBAR }
